<template>
    <access-denied v-if="accessDenied" title="emrpesa" />
    <div style="height: 100%;" v-else>
        <div id="main" v-show="!rotaAninhada">
            <container-loader v-if="isLoading && !$store.getters.isLoading"/>
            <div class="page">
                <div class="tipos-servicos vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">
                                {{ $t("empresas") }}
                                <a
                                    class="pl-1"
                                    v-if="hide.hideInfo"
                                    @click="infoIsHidden()"
                                >
                                    <b-icon
                                        v-if="!hide.infoIsHidden"
                                        icon="eye-off-outline"
                                        type="is-danger"
                                    />
                                    <b-icon
                                        v-if="hide.infoIsHidden"
                                        icon="eye-outline"
                                        type="is-success"
                                    />
                                </a>
                            </h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t($route.meta.contexto)
                                        }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{
                                            $t("empresas")
                                        }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                v-if="
                                    !empresaIntegracao &&
                                    permissaoDadosCadastrais.create
                                "
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="
                                    $router.push({
                                        name: `${$route.meta.abrev}-empresa-dados-cadastrais-new`,
                                    })
                                "
                            >
                                {{ $t("adicionar") }}
                            </button>
                        </div>
                    </div>

                    <div class="search-and-filter">
                        <div class="search-bar">
                            <search-bar
                                :onSearch="debouncedOnSearch"
                            />
                        </div>
                    </div>

                    <div class="registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="empresas"
                            class="data-table"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="f.key != 'excluir' ? $t(f.key) : ''"
                                :width="f.width"
                                :class="{
                                    'excluir-field': f.key == 'excluir',
                                    'label-km': f.key == 'label',
                                }"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'nome'">
                                    <router-link
                                        v-if="permissaoDadosCadastrais.read"
                                        :to="{
                                            name: `${$route.meta.abrev}-empresa-dados-cadastrais-edit`,
                                            params: { id: props.row.id },
                                        }"
                                    >
                                        <pre>{{ props.row[f.key] }}</pre>
                                    </router-link>

                                    <span v-else>{{ props.row[f.key] }}</span>
                                </div>
                                <div v-else-if="f.key == 'cnpj'">
                                    <HideInfo
                                        v-if="!cleanHide"
                                        :value="props.row[f.key]"
                                        :hideInfo="hide.hideInfo"
                                        :infoIsHidden="hide.infoIsHidden"
                                        showPartInfoPosition="end"
                                        :showPartInfoLenght="4"
                                    />
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import EmpresaService from "@/services/vendas/empresa/EmpresaService";
import HideInfo from "@/components/shared/HideInfo";
import { mapState } from "vuex";

export default {
    beforeRouteUpdate(to, from, next) { 
        if (to.name.includes("empresa") && !to.name.includes("empresa-list")) {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados();
            next();
        }
    },
    components: {
        ContainerLoader,
        HideInfo,
    },
    data() {
        return {
            empresaIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("EMPRESA"),
            cleanHide: true,
            empresas: [],
            situacoes: [
                { id: 2, label: "todos" },
                { id: 1, label: "ativos" },
                { id: 0, label: "inativos" },
            ],
            situacao: { id: 2, label: "todos" },
            service: new EmpresaService(this.$http, this.$router),
            fields: [
                { key: "codigo", width: null, sortable: true, sortFn: null },
                { key: "nome", width: null, sortable: true, sortFn: null },
                { key: "rsocial", width: null, sortable: true, sortFn: null },
                { key: "cnpj", width: null, sortable: true, sortFn: null },
                { key: "endereco", width: null, sortable: true, sortFn: null },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            delete: null,
            queryFilter: "",
            column: "nome",
            order: "asc",
            permissao: {},
            permissaoDadosCadastrais: {},
            rotaAninhada: false,
            accessDenied: false,
        };
    },
    created() {        
        this.rotaAninhada = (this.$route.name.includes("empresa") && !this.$route.name.includes("empresa-list"));

        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.$route.meta.abrev == 'ven') {
            this.permissao = this.hasPermissionAccess(
                "vendas",
                "empresa",
                "ven-empresa"
            );
            this.permissaoDadosCadastrais = this.hasPermissionAccess(
                "vendas",
                "empresa",
                "ven-empresa-dados-cadastrais"
            );
        } else if (this.$route.meta.abrev == 'des') {
            this.permissao = this.hasPermissionAccess(
                "despesas",
                "empresa",
                "des-empresa"
            );
            this.permissaoDadosCadastrais = this.hasPermissionAccess(
                "despesas",
                "empresa",
                "des-empresa-dados-cadastrais"
            );
        } else if (this.$route.meta.abrev == 'pro') {
            this.permissao = this.hasPermissionAccess(
                "promotor",
                "empresa",
                "pro-empresa"
            );
            this.permissaoDadosCadastrais = this.hasPermissionAccess(
                "promotor",
                "empresa",
                "pro-empresa-dados-cadastrais"
            );
        } else if (this.$route.meta.abrev == 'agro') {
            this.permissao = this.hasPermissionAccess(
                "agro",
                "empresa",
                "agro-empresa"
            );
            this.permissaoDadosCadastrais = this.hasPermissionAccess(
                "agro",
                "empresa",
                "agro-empresa-dados-cadastrais"
            );
        }

        if (!this.permissao.read) {
            this.accessDenied = true;
            return;
        } 

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    computed: {
        ...mapState(["hide"]),
    },
    methods: {
        infoIsHidden() {
            this.$store.dispatch("infoIsHidden", {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            this.cleanHide = true;
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.empresas = value;
                    this.isEmpty = this.empresas.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error("Erro ao carregar os acertos.");
                })
                .finally((_) => {
                    this.cleanHide = false;
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findAll(column, order, page, limit, situacao, ...params) {
            if(this.$route.meta.abrev == 'ven') {
                return this.service
                .findAllVendas(column, order, page, limit, situacao, ...params);
            }else if(this.$route.meta.abrev == 'pro') {
                return this.service
                .findAllPromotor(column, order, page, limit, situacao, ...params);
            }else if(this.$route.meta.abrev == 'des') {
                return this.service
                .findAllDespesas(column, order, page, limit, situacao, ...params);
            } else {
                return this.service
                .findAllAgro(column, order, page, limit, situacao, ...params);
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let list = body.content.map((m) => {
                return {
                    id: m.id,
                    codigo: m.idempresaerp,
                    cnpj: m.cnpj,
                    nome: m.nome,
                    rsocial: m.rsocial,
                    endereco: m.endereco.toLowerCase(),
                    bairro: m.bairro,
                    cep: m.cep,
                    obs: m.obs,
                };
            });
            return list;
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    min-height: calc(100% - 50px);
    position: relative;

    .page {
        position: relative;
        padding-left: 0;

        .tipos-servicos .search-and-filter {
            display: flex;
            justify-content: space-between;
            margin: 10px 0;

            .search-bar {
                width: 100%;
                padding-right: 10px;
            }
            @media (max-width: 760px) {
                .search-bar {
                    padding-right: 0;
                }
            }
        }
    }
}
</style>
